import {
  browserName,
  isMobile,
  mobileModel,
  mobileVendor,
  osName,
  osVersion,
} from 'react-device-detect';

/**
 * @return {String}
 */
export const getBasicDeviceInfo = () => {
  const basicInfo = `${browserName} ${osName} ${osVersion}`;

  if (isMobile) return `${basicInfo} ${mobileVendor} ${mobileModel}`;

  return basicInfo;
};

/**
 * @param {Object} options
 * @return {Promise}
 */
export const getLocation = (options = {}) =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, options);
  });
